import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Paper,
  TextField,
  Typography,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import axios from "axios";

const EditProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [userData, setUserData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    phone_number: "",
  });

  // Snackbar states
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (msg, severity = "success") => {
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = () => setSnackbarOpen(false);

  useEffect(() => {
    if (!id) return;
    axios
      .get(`http://127.0.0.1:8000/dashboard/profile/${id}`)
      .then((res) => {
        const data = res.data;
        const nameParts = (data.name || "").split(" ");
        const first_name = nameParts[0] || "";
        const last_name = nameParts.slice(1).join(" ") || "";
        setUserData({
          ...data,
          first_name,
          last_name,
        });
      })
      .catch((err) => console.error(err));
  }, [id]);

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      const updatedData = {
        ...userData,
        name: `${userData.first_name || ""} ${userData.last_name || ""}`.trim(),
      };

      await axios.put(
        `http://127.0.0.1:8000/dashboard/profile/${id}`,
        updatedData
      );

      showSnackbar("Profile updated successfully!", "success");

      setTimeout(() => {
        navigate(`/profile/${id}`);
      }, 1500);
    } catch (error) {
      console.error("Update failed:", error.response?.data || error.message);
      showSnackbar("Failed to update profile!", "error");
    }
  };

  if (!userData.email) return <Typography>Loading...</Typography>;

  return (
    <>
      {/* Snackbar Component */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Box sx={{ mt: 8, px: 2, minHeight: "100vh" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography
            sx={{ color: "#888", cursor: "pointer" }}
            onClick={() => navigate(`/profile/${id}`)}
          >
            &lt; Back
          </Typography>
          <Button
            variant="contained"
            sx={{ borderRadius: 20, textTransform: "none", px: 3 }}
            onClick={handleSave}
          >
            Save Changes
          </Button>
        </Box>

        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            p: 3,
            display: "flex",
            alignItems: "stretch",
            gap: 4,
          }}
        >
          <Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Box sx={{ mt: 3 }}>
                <Typography sx={{ fontWeight: 500, color: "#787c84" }}>
                  First Name
                </Typography>
                <TextField
                  name="first_name"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={userData.first_name || ""}
                  onChange={handleChange}
                  InputProps={{
                    sx: {
                      color: "#787c84",
                      mt: 1,
                    },
                  }}
                />
              </Box>

              <Box sx={{ mt: 3 }}>
                <Typography sx={{ fontWeight: 500, color: "#787c84" }}>
                  Last Name
                </Typography>
                <TextField
                  name="last_name"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={userData.last_name || ""}
                  onChange={handleChange}
                  InputProps={{
                    sx: {
                      color: "#787c84",
                      mt: 1,
                    },
                  }}
                />
              </Box>
            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography sx={{ fontWeight: 500, color: "#787c84" }}>
                Upload profile photo
              </Typography>

              <input
                type="file"
                accept="image/*"
                id="profile-photo-upload"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setUserData({ ...userData, profile_photo: file });
                  }
                }}
              />

              <TextField
                fullWidth
                value={
                  userData.profile_photo
                    ? userData.profile_photo.name
                    : "Choose image to upload"
                }
                variant="outlined"
                size="small"
                onClick={() =>
                  document.getElementById("profile-photo-upload").click()
                }
                InputProps={{
                  readOnly: true,
                  sx: { mt: 1, cursor: "pointer" },
                }}
              />
            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography sx={{ fontWeight: 500, color: "#787c84" }}>
                Email Id
              </Typography>
              <Box
                sx={{ display: "flex", alignItems: "center", mt: 1, gap: 0.8 }}
              >
                <TextField
                  name="email"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={userData.email || ""}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      color: "#787c84",
                    },
                  }}
                />
                <Button
                  variant="text"
                  sx={{
                    color: "red",
                    textTransform: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    minWidth: "auto",
                    px: 0.5,
                    fontSize: 12,
                    whiteSpace: "nowrap",
                  }}
                >
                  verify now
                  <InfoOutlined sx={{ fontSize: 16 }} />
                </Button>
              </Box>
            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography sx={{ fontWeight: 500, color: "#787c84" }}>
                Contact No.
              </Typography>
              <Box sx={{ display: "flex", mt: 1 }}>
                <TextField
                  size="small"
                  value="+91"
                  sx={{ width: 70, mr: 1 }}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      color: "#787c84",
                    },
                  }}
                />
                <TextField
                  name="phone_number"
                  size="small"
                  fullWidth
                  value={userData.phone_number || ""}
                  onChange={handleChange}
                  InputProps={{
                    sx: {
                      color: "#787c84",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default EditProfile;
